export default {
    setstartupDatainfo(state, payload) {
        state.startupDataInfo = payload
        state.startUpDataDetails = payload
    },
    updatestartupDatainfo(state, payload) {
        for(let key of Object.keys(payload)){
            state.startUpDataDetails[key] = payload[key]
        }    
        if(payload.key != undefined){
            state.startupDataInfo[payload.key] = payload.content
        }
    },
};